var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 810,
    height: 1433,
    viewBox: "0 0 810 1433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.37,
    filter: "url(#filter0_f_730_698)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 716.216,
    cy: 716.216,
    r: 430.5,
    transform: "rotate(-62 716.216 716.216)",
    fill: "url(#paint0_linear_730_698)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_730_698",
    x: 0.0308533,
    y: 0.0309753,
    width: 1432.37,
    height: 1432.37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 142.8,
    result: "effect1_foregroundBlur_730_698"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_730_698",
    x1: 716.216,
    y1: 422.282,
    x2: 716.216,
    y2: 1146.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.870937,
    stopColor: "#0085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white",
    stopOpacity: 0.903003
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRight);
export default __webpack_public_path__ + "static/media/lightRight.87133319c6c46fe05f2b4aa44f55ee93.svg";
export { ForwardRef as ReactComponent };